const React = require('react');
const {AdminCard} = require('../../../AdminLayout');
const {AdminInput} = require('../../../../FormInputs');

module.exports = ({id, title, formCtx = {}}) => {
  const {data, errors: errorsObj} = (formCtx.state || {});
  const values = data[id] || {};
  const errors = errorsObj[id] || {};

  const onChange = (name, value) => {
    const nextValues = {...values, [name]: value};
    return formCtx.onChange(id, nextValues);
  };

  return (
    <AdminCard
      title={title}
    >
      <div className="mt18">
        <div className="layoutRow fxwWrap mh-6">
          {['daily', 'weekly', 'monthly'].map((name, i) => {
            return (
              <div key={i} className="w1/3 ph6">
                <AdminInput
                  id={`${id}-${name}`}
                  name={name}
                  value={values[name]}
                  error={errors[name]}
                  onChange={onChange}
                />
              </div>
            )
          })}
        </div>
      </div>
    </AdminCard>
  )
}
